export const SocialData=[
    
    {
        plat:"LinkedIN",
        link:"https://www.linkedin.com/in/nipuna-peiris-86a22615a/",
        icon:"/linkedin.png"
    },
    {
        plat:"X",
        link:"https://twitter.com/nipunaprs",
        icon:"/twitter.webp"
    },
    {
        plat:"GitHub",
        link:"https://github.com/nipunaprs",
        icon:"/github.png"
    }
]